<template>
  <div id="app">
    <router-view />
    <ToastContainer />
  </div>
</template>

<script setup>
import ToastContainer from '@/components/common/ToastContainer.vue'
</script>

<style lang="scss">
#app {
  width: 100%;
  height: 100vh;
}
</style>
